import styled from 'styled-components';

const StyledModalHeader = styled.h3(
  props => `
  position: sticky;
  top: 0;
  z-index: ${props.theme.misc.zIndex.large}
  font-size: ${props.theme.font.large.font22};
  font-family: ${props.theme.font.fontFamily};
  font-weight: bold;
  padding: ${props.theme.spacing.large.l20};
  border-bottom: .2rem solid ${props.theme.colors.blue.bgBlue};
  color: ${props.theme.colors.black.base};
  background-color: ${props.theme.colors.white.base};
  border-radius: ${props.theme.misc.borderRadius.xxlarge} ${props.theme.misc.borderRadius.xxlarge} 0 0;
`,
);

export default StyledModalHeader;
